<div class="modal-box">
  <h2 class="modal-title">登录方式升级通知</h2>

  <div class="modal-content" mat-dialog-content>
    <p>为了让您下次登录更便捷，系统已为您自动生成了初始登录密码。</p>

    <div class="highlight-pwd">
      <span class="label">您的初始密码为：</span>
      <span class="pwd-value">手机号后6位</span>
    </div>

    <p class="security-tip">
      下次即可使用密码一键登录。<br />为了您的账号安全，建议尽快修改密码。
    </p>
  </div>

  <div class="modal-actions">
    <button class="btn btn-primary" (click)="changePassword()">修改密码</button>
    <button class="btn btn-secondary" (click)="close()">我知道了</button>
  </div>
</div>
